<template>
  <div class="gender">
    <div class="mark1" v-show="show_add" @click="show_a"> </div>
    <div class="scan" v-show="show_add">
      <div class="crowd">
        <div class="" style="width: 0.32rem;height: 0.32rem;">
        </div>
        <div class="">
          卡片类型
        </div>
        <!-- <div class="" v-else>
          粉丝性别
        </div> -->
        <img src="../../assets/images/x.png" class="x" @click="show_a">
      </div>
      <!-- <div class="careful" :class="num=='不限'?'on':''" @click="num = '不限'" v-if="type==1">
        不限
      </div> -->
      <!-- <div class="careful" :class="num=='不公开'?'on':''" @click="num = '不公开'" v-if="type==0">
        不公开
      </div> -->
      <div class="careful" :class="num=='01'?'on':''" @click="careful2('01')">
        对私账户
      </div>
      <div class="careful" :class="num=='02'?'on':''" @click="careful2('02')">
        对公账户
      </div>
      <!-- <div class="careful" :class="num=='#98'?'on':''" @click="careful2('#98')">
        98#
      </div> -->
      <div class="connection">

      </div>
      <div class="close" @click="careful">
        确认
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'gender',
    props: {
      show_add: {
        type: Boolean,
        default: false
      },
      gender: {
        type: String,
        default: '01'
      },
      type: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        num: ''
      }
    },
    onShow() {
      this.num = this.gender
    },
    mounted() {
      this.num = this.gender
    },
    methods: {
      show_a() {
        this.num = this.gender
        this.$emit('show_gender')
      },
      careful2(res) {
        this.num = res
        this.careful()
      },
      careful() {
        this.$emit('carefuls', this.num)
      },
    }
  }
</script>

<style lang="scss">
  .mark1 {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 1001;
    background: rgba(0, 0, 0, 0.4);
  }

  .scan {
    color: #333333;
    padding: 0.36rem 0 0;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100vw;
    background-color: #fff;
    border-radius: 0.36rem 0.36rem 0 0;
    z-index: 1002;

    .crowd {
      margin-bottom: 0.20rem;
      padding: 0 0.36rem;
      width: 100%;
      display: flex;
      justify-content: space-between;
      font-size: 0.34rem;
      font-weight: bold;

      .x {
        width: 0.32rem;
        height: 0.32rem;
      }
    }

    .careful {
      margin-left: 0.30rem;
      width: 6.90rem;
      height: 1.08rem;
      line-height: 1.08rem;
      text-align: center;
      font-size: 0.32rem;
      color: #333;
      border-bottom: 1px solid #F5F6F8;
    }

    .on {
      color: #0099ff;
    }

    .connection {
      height: 0.20rem;
      width: 100vw;
      background-color: #F7F8FA;
    }

    .close {
      height: 1.07rem;
      background-color: #fff;
      line-height: 1.07rem;
      text-align: center;
      width: 100vw;
      font-size: 0.32rem;
      color: #666;
    }
  }
</style>
